import { SafeResourceUrl } from "@angular/platform-browser";
import { createDefaultLoadable, Loadable } from "../../models";
import { IReport } from '../../models/report.model';

export interface IReportSummariesState extends Loadable {
    reports: IReport[]
}

export interface ISelectedReportURLState extends Loadable {
    url: SafeResourceUrl | null
}

export interface IReportingState {
    summaries: IReportSummariesState,
    selectedReport: IReport | null,
    selectedReportURL: ISelectedReportURLState
}

export function createInitialReportingState(): IReportingState {
    const selected = localStorage.getItem("selectedReport")

    return {
        selectedReport: (selected !== null) ? JSON.parse(selected) : null,
        selectedReportURL: {
          ...createDefaultLoadable(),
          url: null
        },
        summaries: {
            ...createDefaultLoadable(),
            reports: []
        }
    }
}
